// ABOUTME: Behavior log table section with pagination and edit/delete actions
// ABOUTME: Wraps BehaviorEventsTable with permission checks for current user

import React from 'react';
import {
  Box,
  Paper,
  Typography
} from '@mui/material';
import { Timeline } from '@mui/icons-material';
import BehaviorEventsTable, { BehaviorEventEntry } from '../BehaviorEventsTable';

interface BehaviorLogSectionProps {
  events: BehaviorEventEntry[];
  totalCount: number;
  page: number;
  rowsPerPage: number;
  sortField: string;
  sortDirection: 'asc' | 'desc';
  loading: boolean;
  currentUserId?: number;
  isAdmin?: boolean;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  onSort: (field: string) => void;
  onEdit: (event: BehaviorEventEntry) => void;
  onDelete: (event: BehaviorEventEntry) => void;
}

const BehaviorLogSection: React.FC<BehaviorLogSectionProps> = ({
  events,
  totalCount,
  page,
  rowsPerPage,
  sortField,
  sortDirection,
  loading,
  currentUserId,
  isAdmin,
  onPageChange,
  onRowsPerPageChange,
  onSort,
  onEdit,
  onDelete
}) => {
  return (
    <Box sx={{ mt: 4 }} data-testid="behavior-log-section">
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Timeline />
          Behavior Log
        </Typography>

        <BehaviorEventsTable
          events={events}
          totalCount={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          sortConfig={{ field: sortField, direction: sortDirection }}
          loading={loading}
          showChildColumn={false}
          showEditActions={true}
          canEditDelete={(event) => currentUserId === event.recordedByUserId || Boolean(isAdmin)}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          onSort={onSort}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </Paper>
    </Box>
  );
};

export default BehaviorLogSection;
